import React from 'react'
import PropTypes from 'prop-types'
import Seo from '../../../../components/seo'

const StoreSeo = ({
    name,
    city,
    stateCode,
    c_pageTitle,
    c_pageDescription,
    location,
    storeSeoData
}) => {
    return (
        <Seo
            title={c_pageTitle || `Cavenders Western Wear - ${name} | ${city}, ${stateCode}`}
            description={c_pageDescription}
        >
            <script type="application/ld+json">{JSON.stringify(storeSeoData)}</script>
            <link
                rel="canonical"
                href={'https://www.cavenders.com' + location.pathname + location.search}
            ></link>
        </Seo>
    )
}

export default StoreSeo

StoreSeo.propTypes = {
    name: PropTypes.string,
    city: PropTypes.string,
    stateCode: PropTypes.string,
    c_pageTitle: PropTypes.string,
    c_pageDescription: PropTypes.string,
    location: PropTypes.object,
    storeSeoData: PropTypes.object
}
